import Variable from '../../constants/constants.json';

const { handleExcception } = require('../../api/sentryExceptionHandler');
const { createRequest } = require('../../api/client');

export const saveClient = async (data) => {
    const options = {
        url: `${Variable.backendUrl}/clients/saveClient`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
    };
    try {
        await createRequest(options);
    } catch (err) {
        handleExcception(err);
        throw new Error(err);
    }
};

export const getInstanceToEdit = async (tenantId) => {
    const options = {
        url: `${Variable.backendUrl}/clients/getClient`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        qs: {
            tenantId
        }
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        return err;
    }
};

export const updateFrom = (data, name) => ({
    type: name,
    data
});

export const removeClient = async (tenantId) => {
    const options = {
        url: `${Variable.backendUrl}/clients/deleteClient/${tenantId}`,
        method: 'DELETE'
    };
    try {
        const data = await createRequest(options);
        return data;
    } catch (err) {
        handleExcception(err);
        return err;
    }
};
